import { useContext } from 'react';
import { GroupEntityTagsContext } from '../context.js';

export default function useGroupEntityTags() {
  return useContext(GroupEntityTagsContext);
}

export { useGroupEntityTags };